<div class="all-title-box page-hero about-hero">
  <div class="hero-overlay"></div>
  <div class="container text-center hero-content">
    <span class="eyebrow">ANYSPACE Inc.</span>
    <h1>About Us</h1>
    <p>Building smarter, data-driven assets for modern industries.</p>
  </div>
</div>

<main class="modern-page about-page-redesign">
  <section class="intro-card">
    <span class="section-kicker">Who We Are</span>
    <h1>Technology for a World of Smarter Assets</h1>
    <p>Our mission is to empower industries with data-driven insights and innovative solutions that maximize efficiency, sustainability, and customer satisfaction.</p>
  </section>

  <section class="feature-grid two-column">
    <article class="feature-card vision-card">
      <div class="card-icon">◎</div>
      <div>
        <h3>Our Vision</h3>
        <p>We envision a future where businesses leverage cutting-edge technology to streamline operations, personalize experiences, and make data-informed decisions seamlessly. Through AI, IoT, and AR capabilities, we aim to support technological evolution across multiple sectors.</p>
      </div>
    </article>

    <article class="feature-card vision-card">
      <div class="card-icon">↗</div>
      <div>
        <h3>Our Approach</h3>
        <p>We combine real-time data, intelligent automation, and scalable application design to help organizations improve operations, reduce complexity, and unlock long-term value from their assets.</p>
      </div>
    </article>
  </section>

  <section class="strategy-section">
    <div class="section-heading">
      <span></span>
      <h2>Core Expertise</h2>
      <span></span>
    </div>

    <div class="expertise-grid">
      <article class="mini-card">
        <span>01</span>
        <h3>Smart Logistics and Transportation</h3>
        <p>Enabling real-time tracking, predictive maintenance, route optimization, and smarter fleet operations.</p>
      </article>

      <article class="mini-card">
        <span>02</span>
        <h3>Real Estate and Smart Infrastructure</h3>
        <p>Supporting IoT-driven automation, energy efficiency, and customized tenant experiences.</p>
      </article>

      <article class="mini-card">
        <span>03</span>
        <h3>Financial and Media Solutions</h3>
        <p>Providing risk management, portfolio optimization, audience engagement, and data analytics.</p>
      </article>

      <article class="mini-card">
        <span>04</span>
        <h3>Data-Driven Decision Support</h3>
        <p>Offering real-time analytics, demand forecasting, and asset monitoring tools across sectors.</p>
      </article>
    </div>
  </section>

  <section class="insight-grid">
    <article class="insight-card success">
      <div class="pill-icon">✓</div>
      <h2>Scalable Growth</h2>
      <p>Our solutions are designed to adapt as business requirements evolve, helping organizations move from early implementation to long-term operational maturity.</p>
    </article>

    <article class="insight-card blue-card">
      <div class="pill-icon">⌁</div>
      <h2>Operational Efficiency</h2>
      <p>Predictive analytics and real-time monitoring help streamline operations, reduce expenses, and improve decision-making across complex environments.</p>
    </article>

    <article class="insight-card conclusion-card">
      <div class="pill-icon">◆</div>
      <h2>Sustainable Innovation</h2>
      <p>We design with a commitment to responsible growth, helping partners align technology investments with sustainability and long-term value creation.</p>
    </article>
  </section>
</main>
